import "./index.scss";

const Input = ({ title, placeholder, value, name, onChange }) => {
  return (
    <div style={{ flex: 1 }}>
      <p className="input-title">{title}</p>
      <input
        name={name}
        value={value}
        onChange={onChange}
        className="input-default"
        placeholder={placeholder}
      />
    </div>
  );
};

export default Input;
